module.exports = __webpack_public_path__ + "static/media/break-horizontal.a0eea1b2.svg";